import React from 'react'

import Flag from '../../subcomponents/Flag'
import ContentBox from '../../subcomponents/ContentBox'

import {default as t} from '../../utils/Translate'

const Offer = ({className, campaign, image, isCcMedien, isWebComponent, partnerLogo, flagFilter, logoFilter=[], ccMedienFilter=[], lang, isArrow=false, noBorder=false, disableSuperscripts}) => {
    return (
        <div className={'mam3-type offer ' + className + (!partnerLogo ? ' no-logo' : '') + (noBorder ? '' : ' border' )}>
        <div className="hero-wrapper">
          {
              isCcMedien ?
                  ['Alle','CC Medien'].some(val => flagFilter.includes(val)) &&
                  <Flag text={campaign.flagstoerer} appearance={campaign.flageye_catcher} /> :
                  ['Alle', 'Web'].some(val => flagFilter.includes(val)) &&
                  <Flag text={campaign.flagstoerer} appearance={campaign.flageye_catcher} />
          }

            <img src={image} className="hero img-fluid" role="presentation" alt="Hero" />
        </div>

        {isWebComponent
            ?
                <ContentBox
                    disableSuperscripts={disableSuperscripts}
                    campaign={campaign}
                    isArrow={isArrow}
                    logo={
                        logoFilter.includes('Web Logo verbergen')
                        ? ''
                        : partnerLogo
                    }
                >
                    {!ccMedienFilter.includes('Teaser Topic verbergen') ? `__${campaign.label_teaser_topic}__` : ''}
                    {`${t(campaign.title_3_long, lang)}\n`}
                    {`__${t(campaign.main_benefit_components_web, lang)}__`}
                </ContentBox>
            :
                <ContentBox
                    disableSuperscripts={disableSuperscripts}
                    campaign={campaign}
                    isArrow={isArrow}
                    logo={!ccMedienFilter.includes('Logo verbergen') ? partnerLogo : ''}
                >
                    {!ccMedienFilter.includes('Teaser Topic verbergen') ? `__${campaign.label_teaser_topic}__` : ''}
                    {`${t(campaign.title_3_long, lang)}\n`}
                    {`__${t(campaign.main_benefit_components_web, lang)}__`}
                </ContentBox>
         }

    </div>
    )
}

Offer.placeholder = {
    campaign: {
        title_3_long: 'Exciting offers are waiting for you',
        main_benefit_components_web: 'Up to 5,000{M}',
        flagstoerer: null
    }
}

export default Offer



// WEBPACK FOOTER //
// ./src/components/ads/mam3/Offer.js